import React from 'react'
import { useWishlist } from '../Context/WishlistContext'
import { useAuth } from '../Context/AuthContext'
import { useNavigate } from 'react-router-dom'

function WishlistButton({ product, className = '', style = {} }) {
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist()
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const inWishlist = isInWishlist(product.id)

  const handleClick = (e) => {
    e.stopPropagation()

    if (!isAuthenticated) {
      navigate('/login')
      return
    }

    if (inWishlist) {
      removeFromWishlist(product.id)
    } else {
      addToWishlist(product)
    }
  }

  return (
    <button
      onClick={handleClick}
      className={`${className} ${inWishlist ? 'active' : ''}`.trim()}
      style={style}
      aria-label={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
      title={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
      aria-pressed={inWishlist}
    >
      <i
        className={`${inWishlist ? 'fa-solid' : 'fa-regular'} fa-heart`}
        aria-hidden="true"
      />
    </button>
  )
}

export default WishlistButton
